/**
 * Rocnovel 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const rocnovelPaymentConfig: BrandPaymentConfig = {
  brand: 'rocnovel',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/rocnovel/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/rocnovel/vip_bg.webp',
      memberSubscribeBg: '/images/rocnovel/member_subscribe_bg.webp',
      vipIcon: '/images/rocnovel/vip_icon2.png',
      vipDiscountIcon: '/images/rocnovel/vip_discount.png',
      discountBg: '/images/rocnovel/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #A778FE, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF873F',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#F3EFFF',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #BEA9FF 0%, #D3C5FB 70%, #F3EFFF 100%)',
      pinkGradient: 'linear-gradient(132deg, #F961BC 0%, #F74984 100%)',
      memberSubscribeBg: '/images/rocnovel/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
